import { useMutation } from 'react-query';
import { createShortenLink } from '../../services/shortenLinksService';

export function useCreateShortenLink() {
  return useMutation(({ artistId, memberId }: { artistId: string; memberId: string }) =>
    createShortenLink(artistId, memberId)
  );
}
